import { RequestsApi } from '../RequestsApi';

/**
 * Live Readings waitlist (HORO-10471).
 *
 * `join` is reachable anonymously — RequestsApi attaches the Authorization
 * header only when a token exists, which is exactly the behaviour the endpoint
 * expects (auth is optional there). `dismissPromo` requires a signed-in user,
 * but the promo modal is only ever shown to signed-in users anyway.
 */
class WaitlistApi extends RequestsApi {
    async join(email) {
        return await this.request('/waitlist', 'post', { email });
    }

    // `via` records whether this was the X / backdrop / Esc ('close') or the
    // explicit "Not Interested" decline. Stored on the user document so the
    // decline rate survives ad blockers, which GA4 does not.
    async dismissPromo(via) {
        return await this.request('/waitlist/promo-dismiss', 'post', { via });
    }
}

export default new WaitlistApi();
